import { styled } from 'styled-components'

export const Root = styled.div`
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: space-around;
`

export const Separator = styled.div`
  width: 1px;
  background-color: #C2CBCF;
  height: 2rem;
`
